import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOpened = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8898 13.1558C20.9649 12.9908 20.9649 12.8036 20.8898 12.6386C20.3661 11.4888 17.9049 6.89722 12 6.89722C6.09511 6.89722 3.63395 11.4888 3.11023 12.6386C3.03506 12.8036 3.03506 12.9908 3.11023 13.1558C3.63395 14.3056 6.09511 18.8972 12 18.8972C17.9049 18.8972 20.3661 14.3056 20.8898 13.1558Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15.8972C13.6569 15.8972 15 14.5541 15 12.8972C15 11.2404 13.6569 9.89722 12 9.89722C10.3431 9.89722 9 11.2404 9 12.8972C9 14.5541 10.3431 15.8972 12 15.8972Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 13.8972C12.5523 13.8972 13 13.4495 13 12.8972C13 12.3449 12.5523 11.8972 12 11.8972C11.4477 11.8972 11 12.3449 11 12.8972C11 13.4495 11.4477 13.8972 12 13.8972Z",
			fill: "currentColor"
		})
	]
});
export default SvgEyeOpened;
